import React from 'react';
import './styles/app.css';
import AppHeader from "./core/AppHeader";
import AppFooter from "./core/AppFooter";
import {createTheme, NextUIProvider} from "@nextui-org/react";
import About from "./pages/About";
import Work from "./pages/Work";

function App() {
    const theme = createTheme({
        type: 'light',
    });

    return (
        <NextUIProvider theme={theme}>
            <AppHeader/>
            <div id={"wrap"}>
                <div className={"cube reverse-front"}>
                    <section className={"page active face front"} id={"work"}>
                        <div className={"act-table text-center"}>
                            <div className={"act-table-cell ver-middle"}>
                                <Work/>
                            </div>
                        </div>
                    </section>
                    <section className={"page face back"} id={"about"}>
                        <div className={"act-table"}>
                            <div className={"act-table-cell ver-middle"}>
                                <About/>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <AppFooter/>
        </NextUIProvider>
    );
}

export default App;
